
import Vue from 'vue'

import EditPanel from './components/EditPanel.vue'
import EditMenu from './components/EditMenu.vue'
import EditPopover from './components/EditPopover.vue'

import Tooltip from 'vue-directive-tooltip';
import 'vue-directive-tooltip/dist/vueDirectiveTooltip.css';

import VueCodemirror from 'vue-codemirror'
import 'codemirror/lib/codemirror.css'
import 'codemirror/mode/htmlmixed/htmlmixed.js'
import 'codemirror/mode/javascript/javascript.js'
import 'codemirror/addon/fold/foldcode.js'
import 'codemirror/addon/fold/foldgutter.js'
import 'codemirror/addon/fold/foldgutter.css'
import 'codemirror/addon/fold/brace-fold.js'
import 'codemirror/addon/fold/xml-fold.js'
import 'codemirror/addon/fold/indent-fold.js'
import 'codemirror/addon/lint/lint.js'
import 'codemirror/addon/lint/lint.css'
import 'codemirror/addon/lint/javascript-lint.js'
import 'codemirror/addon/merge/merge.js'
import 'codemirror/addon/merge/merge.css'
import DiffMatchPatch from 'diff-match-patch'
// DiffMatchPatch config with global
window.diff_match_patch = DiffMatchPatch
window.DIFF_DELETE = -1
window.DIFF_INSERT = 1
window.DIFF_EQUAL = 0

import { JSHINT } from 'jshint'

window.JSHINT = JSHINT

window.__editModeAvailable = true;

export default () => {
    Vue.use(Tooltip);
    Vue.use(VueCodemirror);
    Vue.component('EditPanel', EditPanel)
    Vue.component('EditMenu', EditMenu)
    Vue.component('EditPopover', EditPopover)
}
